import { Link } from "react-router-dom";
import React from "react";

function Footer() {
  return (
    <div>
      <footer
        className="footer-wrapper footer2 bg-dark style-two jarallax"
        data-jarallax
        data-jarallax-speed="0.2"
        style={{ backgroundImage: "url(assets/img/bg-img/1.jpg)" }}
      >
        {/* Newsletter */}
        <div className="newsletter-wrapper">
          <div className="container">
            <div className="d-flex flex-wrap align-items-center gap-5 justify-content-around">
              <div className="section-heading">
                <h2 className="mb-0 text-white">Sign Up for Updates</h2>
              </div>
              {/* Subscribe Form */}
              <form action="#" className="subscribe-form">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email address"
                  id="subscribeEmail"
                />
                <button className="btn btn-primary">
                  <span>
                    <span className="d-none d-xl-block">Subscribe Now</span>{" "}
                    <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    <span className="d-none d-xl-block">Subscribe Now</span>{" "}
                    <i className="ti ti-arrow-up-right"></i>
                  </span>
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="footer-line"></div>

        <div className="footer2-middle-wrap">
          <div className="container">
            <div className="row align-items-center g-5 g-md-4 g-xl-5">
              {/* Footer Card */}
              <div className="col-12 col-sm-6 col-md-4 col-xl-4">
                <div className="footer-contact-card d-flex align-items-center gap-3 mb-4">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1_1496)">
                        <mask
                          id="mask0_1_1496"
                          style={{ maskType: "luminance" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="40"
                          height="40"
                        >
                          <path
                            d="M0 3.8147e-06H40V40H0V3.8147e-06Z"
                            fill="white"
                          />
                        </mask>
                        <g mask="url(#mask0_1_1496)">
                          <path
                            d="M22.7676 0.791484C31.8387 0.791484 39.2184 8.17117 39.2184 17.2422"
                            stroke="#D3A574"
                            strokeWidth="1.5625"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M22.7676 5.49141C29.2466 5.49141 34.5184 10.7633 34.5184 17.2422"
                            stroke="#D3A574"
                            strokeWidth="1.5625"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M22.7676 10.1923C26.6552 10.1923 29.8176 13.3547 29.8176 17.2422"
                            stroke="#D3A574"
                            strokeWidth="1.5625"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M22.7676 14.8922C24.0652 14.8922 25.1176 15.9446 25.1176 17.2422"
                            stroke="#D3A574"
                            strokeWidth="1.5625"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M14.6426 25.375C14.6426 25.8065 14.2928 26.1562 13.8613 26.1562C13.4299 26.1562 13.0801 25.8065 13.0801 25.375C13.0801 24.9436 13.4299 24.5938 13.8613 24.5938C14.2928 24.5938 14.6426 24.9436 14.6426 25.375Z"
                            fill="#D3A574"
                          />
                          <path
                            d="M11.5777 22.7038C11.0821 22.0528 10.6124 21.3806 10.1701 20.6884C9.5889 19.7783 9.76468 18.5728 10.5279 17.8095L13.1803 15.1571C13.7513 14.5869 13.7513 13.6611 13.1803 13.0907L6.93804 6.8486C6.36773 6.27743 5.44202 6.27743 4.87171 6.8486L3.29195 8.42821C0.727962 10.9916 0.0349928 14.904 1.64437 18.1524C4.50765 23.9329 10.3998 32.7938 21.7514 38.3602C25.01 39.9572 28.9405 39.2799 31.5061 36.7142L33.1217 35.0985C33.6927 34.5283 33.6927 33.6025 33.1217 33.0313L26.8794 26.79C26.3091 26.2188 25.3834 26.2188 24.8131 26.79L22.1608 29.4424C21.3974 30.2056 20.192 30.3813 19.2818 29.8002C18.2972 29.1709 17.3523 28.4859 16.4515 27.7494"
                            stroke="#D3A574"
                            strokeWidth="1.5625"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_1_1496">
                          <rect width="40" height="40" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div>
                    <p className="text-white mb-0">Phone:</p>
                    <p className="mb-0 text-white">0-869-878-08-68</p>
                  </div>
                </div>

                <div className="footer-contact-card d-flex align-items-center gap-3 mb-4">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1_1516)">
                        <path
                          d="M20.0766 3.12502C19.6446 3.1219 19.2922 3.46955 19.2891 3.9008C19.286 4.33205 19.6328 4.6844 20.0649 4.68752C20.4961 4.69065 20.8485 4.34377 20.8516 3.91252C20.8547 3.48127 20.5078 3.12893 20.0766 3.12502Z"
                          fill="#D3A574"
                        />
                        <path
                          d="M20.0411 7.81264C17.0246 7.79123 14.5542 10.2248 14.5314 13.2403C14.5087 16.2557 16.9435 18.7273 19.9591 18.75C19.9731 18.7501 19.987 18.7502 20.0009 18.7502C22.9973 18.7502 25.4461 16.3239 25.4688 13.3223C25.4915 10.3071 23.0567 7.83537 20.0411 7.81264ZM20.0008 17.1877C19.9909 17.1877 19.9806 17.1877 19.9708 17.1876C17.8168 17.1713 16.0776 15.4059 16.0938 13.252C16.11 11.1079 17.8591 9.37491 19.9994 9.37491C20.0092 9.37491 20.0195 9.37499 20.0294 9.37507C22.1834 9.39132 23.9226 11.1568 23.9063 13.3106C23.8901 15.4548 22.1411 17.1877 20.0008 17.1877Z"
                          fill="#D3A574"
                        />
                        <path
                          d="M23.4077 3.717C23.0013 3.57279 22.5545 3.78568 22.4103 4.1924C22.2662 4.59912 22.4791 5.0456 22.8857 5.18982C26.3269 6.40943 28.6203 9.68686 28.5928 13.3452C28.5896 13.7766 28.9367 14.1291 29.3682 14.1323C29.3701 14.1323 29.3721 14.1323 29.3742 14.1323C29.8028 14.1323 30.152 13.7864 30.1553 13.3569C30.1878 9.03295 27.4761 5.15896 23.4077 3.717Z"
                          fill="#D3A574"
                        />
                        <path
                          d="M24.7936 29.4096C29.9899 22.7209 33.2374 19.233 33.2812 13.3811C33.3362 6.01837 27.361 0 19.9988 0C12.7226 0 6.77427 5.89282 6.71895 13.1819C6.67427 19.1925 9.98201 22.6756 15.2142 29.4085C10.0091 30.1863 6.71895 32.1408 6.71895 34.5313C6.71895 36.1327 8.19911 37.5696 10.8869 38.5774C13.3332 39.4948 16.5697 40 20.0001 40C23.4305 40 26.667 39.4948 29.1133 38.5774C31.801 37.5695 33.2812 36.1326 33.2812 34.5312C33.2812 32.142 29.9941 30.188 24.7936 29.4096ZM8.28138 13.1937C8.33013 6.76173 13.5782 1.5625 19.999 1.5625C26.4958 1.5625 31.7672 6.87408 31.7188 13.3695C31.6772 18.9268 28.2333 22.3516 22.7351 29.519C21.7544 30.7969 20.8537 32.005 20.0012 33.1868C19.1512 32.0043 18.2686 30.8178 17.2732 29.5186C11.5477 22.0511 8.23903 18.8851 8.28138 13.1937ZM20.0001 38.4376C13.293 38.4376 8.28138 36.3753 8.28138 34.5313C8.28138 33.1638 11.2773 31.4363 16.3147 30.8381C17.4282 32.2991 18.4044 33.6265 19.3619 34.9821C19.5082 35.1891 19.7459 35.3124 19.9994 35.3126C19.9996 35.3126 19.9998 35.3126 20.0001 35.3126C20.2534 35.3126 20.4909 35.1898 20.6374 34.9831C21.5859 33.6451 22.5888 32.2851 23.6928 30.839C28.7255 31.4378 31.7188 33.1648 31.7188 34.5314C31.7187 36.3753 26.7072 38.4376 20.0001 38.4376Z"
                          fill="#D3A574"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_1516">
                          <rect width="40" height="40" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div>
                    <p className="text-white mb-0">Address:</p>
                    <p className="mb-0 text-white">
                      13 Division st, New York, 16004
                    </p>
                  </div>
                </div>

                <div className="footer-contact-card d-flex align-items-center gap-3">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <mask
                        id="mask0_1_1534"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="40"
                        height="40"
                      >
                        <path
                          d="M0 3.8147e-06H40V40H0V3.8147e-06Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask0_1_1534)">
                        <path
                          d="M3.76172 38.2656L14.0034 28.0239"
                          stroke="#D3A574"
                          strokeWidth="1.5625"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M36.2368 38.2656L25.877 27.9058"
                          stroke="#D3A574"
                          strokeWidth="1.5625"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M23.5156 39.2148H33.9446C35.7356 39.2148 37.1875 37.763 37.1875 35.972V17.857C37.1875 16.9973 36.8461 16.1727 36.2384 15.5647L33.4312 12.7563"
                          stroke="#D3A574"
                          strokeWidth="1.5625"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6.54383 12.7899L3.76297 15.5644C3.15438 16.1727 2.8125 16.9977 2.8125 17.8582V35.9719C2.8125 37.7629 4.26438 39.2148 6.05539 39.2148H16.4843"
                          stroke="#D3A574"
                          strokeWidth="1.5625"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M25.6765 4.99609L21.4653 0.782422C20.3287 0.782031 19.6915 0.781875 18.5549 0.781484L14.3379 4.99602"
                          stroke="#D3A574"
                          strokeWidth="1.5625"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M36.8638 16.8394L22.3033 31.4089C21.0372 32.6757 18.9839 32.6763 17.7171 31.4102L3.19141 16.8934"
                          stroke="#D3A574"
                          strokeWidth="1.5625"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M20.9449 19.7192H19.7021C17.8808 19.7192 16.4044 18.2427 16.4044 16.4215C16.4044 14.6002 17.8808 13.1237 19.7021 13.1237C21.413 13.1237 22.8 14.5106 22.8 16.2216V18.03C22.8 19.0777 23.6494 19.9271 24.6972 19.9271C25.7449 19.9271 26.5943 19.0777 26.5943 18.03V16.429C26.5943 12.7866 23.6416 9.83399 19.9993 9.83399C16.357 9.83399 13.4043 12.7866 13.4043 16.429C13.4043 20.127 16.4022 23.125 20.1003 23.125H24.8486"
                          stroke="#D3A574"
                          strokeWidth="1.5625"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6.5625 20.25V7.33789C6.5625 6.04344 7.6118 4.99414 8.90625 4.99414H31.0937C32.3882 4.99414 33.4375 6.04344 33.4375 7.33789V19.9941"
                          stroke="#D3A574"
                          strokeWidth="1.5625"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </svg>
                  </div>
                  <div>
                    <p className="text-white mb-0">Email:</p>
                    <p className="mb-0 text-white">info@paraclearth.com</p>
                  </div>
                </div>
              </div>

              {/* Footer Card */}
              <div className="col-12 col-sm-6 col-md-4 col-xl-4">
                <div className="footer-card middle text-center">
                  {/* Footer Logo */}
                  <Link to="#" className="d-block mb-3">
                    <img src="assets/img/core-img/logo-big.png" alt="" />
                  </Link>

                  <p className="text-white mb-5">
                    Lorem ipsum dolor amet natum latine copiosa quo suas labore
                  </p>

                  {/* Social Nav */}
                  <div className="social-nav">
                    <Link to="#">
                      <i className="ti ti-brand-facebook"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-x"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-linkedin"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-instagram"></i>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-1 col-xl-1 d-none d-md-block"></div>

              {/* Footer Card */}
              <div className="col-12 col-sm-8 col-md-3 col-xl-3">
                <div className="footer-card">
                  {/* Footer Nav */}
                  <ul className="footer-nav ps-0">
                    <li>
                      <Link to="#">
                        Coaching <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        Business <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        Personal <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        Consulting <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        Financial <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        Courses <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        Criminal <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        About <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        Services <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        Blog <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        Contact <i className="ti ti-arrow-up-right"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p className="mb-0 copyright footer2">
          Copyright © <span id="year"></span> <Link to="#">Nano Theme</Link>
        </p>
      </footer>
    </div>
  );
}

export default Footer;
